import Phaser from "phaser";
import { SCENE_KEYS } from "../constants.js";

export class BootScene extends Phaser.Scene {
  public constructor() {
    super(SCENE_KEYS.boot);
  }

  public create(): void {
    this.scene.start(SCENE_KEYS.battle);
  }
}

